import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory, useParams, Link } from "react-router-dom";

//UI
import { Form, Message, Divider, Loader, Breadcrumb, Header, Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import ChangeBookingTypeModal from "../../../../components/space/ChangeBookingTypeModal";

//Actions
import { createBooking } from "../../../../redux/actions/reservations/booking/createBooking";
import { updateBooking } from "../../../../redux/actions/reservations/booking/updateBooking";
import { initialStateBooking } from "../../../../redux/actions/reservations/booking/fetchBooking";
import { fetchAvailabilityCabin } from "../../../../redux/actions/reservations/cabin/fetchAvailabilityCabin";
import { findBookingPartner } from "../../../../redux/actions/reservations/booking/findBookingPartner";
import { fetchBookingFormCustom, initialStateBookingFormCustom } from "../../../../redux/slices/custom/reservations/cruise/booking/customBookingForm.slice";

//Components
import HeadDetail from "../../../../components/headDetail";
import HeadDetailReservation from "../../../../components/headDetailReservation";

// Resources
import { scrollToTop } from "../../../resources/utils";
import { closeModal, initialStateValidateBooking, isRateGoingToChangeOnUpdate } from "../../../../redux/slices/custom/reservations/cruise/booking/checkBookingForm.slice";

export default function BookingForm() {
  let history = useHistory();
  let { cruise_id, reservation_id, booking_id } = useParams();
  const { t } = useTranslation();
  const { register, handleSubmit, errors } = useForm();
  const { showModal, isUpdate } = useSelector((state) => state.validateBooking);
  const bookingStateCustom = useSelector((state) => state.customBookingForm);
  const bookingState = useSelector((state) => state.bookingReducer);
  const [cabinId, setCabinId] = useState("");
  const [isFamilyRoom, setIsFamilyRoom] = useState(null);
  const [dataForm, setDataForm] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBookingFormCustom(reservation_id, cruise_id, booking_id));
    scrollToTop();
    return () => {
      dispatch(initialStateValidateBooking());
      dispatch(initialStateBookingFormCustom());
      dispatch(initialStateBooking());
    };
  }, []);

  useEffect(() => {
    setIsFamilyRoom(bookingState.booking?.family_room ? bookingState.booking?.family_room : bookingStateCustom.booking.family_room);
  }, [bookingStateCustom.booking, bookingState.booking?.family_room]);

  useEffect(() => {
    if (isUpdate === false) {
      dispatch(updateBooking(cruise_id, reservation_id, booking_id, dataForm));
    }
  }, [isUpdate]);

  if (bookingStateCustom.fetching || bookingState.fetching) {
    return <Loader active inline />;
  }

  const handleCabinChange = (cabin_id) => {
    if (cabin_id) {
      dispatch(fetchAvailabilityCabin(cabin_id));
      dispatch(findBookingPartner(reservation_id, cabin_id))
      setIsFamilyRoom(bookingStateCustom.booking.family_room ? bookingStateCustom.booking.family_room : false);
    }
  };

  const onSubmit = (data) => {
    data["cruise_id"] = cruise_id;
    setDataForm(data)
    if (booking_id) {
      dispatch(isRateGoingToChangeOnUpdate(data, reservation_id, booking_id));
    } else if (reservation_id) {
      dispatch(createBooking(reservation_id, data));
    }
  };

  if (bookingState.message === "resource created successfully" || bookingState.message === "resource updated successfully" || bookingState.message === "no changes") {
    history.go(-1);
  }

  const handleFamilyRoomChange = () => {
    setIsFamilyRoom(!isFamilyRoom);
  };

  return (
    <>
      {bookingState.error ? (
        <Message negative content={t(bookingState.error)} />
      ) : (
        ""
      )}
      <Breadcrumb>
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/cruise-detail`} className="section">{bookingStateCustom.cruise.code}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations`} className="section"> {t("reservation_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings`} className="section"> {t("booking_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active>{t("booking_cabin")}</Breadcrumb.Section>
      </Breadcrumb>
      <Divider variant="fullWidth" />

      <HeadDetail
        yacht_name={bookingStateCustom.cruise.yacht_name}
        itinerary_name={bookingStateCustom.cruise.itinerary_name}
        start_date={bookingStateCustom.cruise.start_date_format}
        end_date={bookingStateCustom.cruise.end_date_format}
      />

      <HeadDetailReservation
        reservation_date={bookingStateCustom.reservation.creation_date}
        reservation_agency={bookingStateCustom.reservation.agency_name}
        reservation_executive={bookingStateCustom.reservation.user}
        reservation_type={bookingStateCustom.reservation.cruise_type}
      />

      <br />
      <Form id="booking-form" onSubmit={handleSubmit(onSubmit)}>
        <Header as='h3' dividing>{t("general_information_tag")}</Header>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("booking_cabin")}</label>
            <select aria-expanded="true" name="cabin_id" value={cabinId ? cabinId : bookingStateCustom.booking.cabin_id} ref={register({ required: true })}
              onChange={(event) => {
                setCabinId(event.target.value);
                handleCabinChange(event.target.value);
              }}
            >
              <option></option>
              {bookingStateCustom.cabins.map((cabin) => (
                <option key={cabin.cabin_id} value={cabin.cabin_id}>
                  {cabin.cabin_name}
                </option>
              ))}
            </select>
            {errors.cabin_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>

          <Form.Field></Form.Field>
          <Form.Field>
            <label>{t("booking_single")}</label>
            <div className="ui checkbox">
              <input type="checkbox" name="single" defaultChecked={bookingStateCustom.booking.single === 1} ref={register} />
              <label></label>
            </div>
          </Form.Field>

          <Form.Field>
            <label>{t("booking_double")}</label>
            <div className="ui checkbox">
              <input type="checkbox" name="matrimonial" ref={register} defaultChecked={bookingStateCustom.booking.matrimonial} />
              <label></label>
            </div>
          </Form.Field>
          <Form.Field>
            <label>{t("booking_family")}</label>
            <div className="ui checkbox">
              <input type="checkbox" name="family_room" ref={register} defaultChecked={bookingState.booking?.family_room ? bookingState.booking?.family_room : bookingStateCustom.booking.family_room} onChange={handleFamilyRoomChange} />
              <label></label>
            </div>
          </Form.Field>
          {
            isFamilyRoom && (!bookingStateCustom.reservation.charter && !bookingStateCustom.reservation.contract_rate && !bookingStateCustom.reservation.ikarus_rate) ?
              <Form.Field>
                <label>{t("space_ratePriceInclude")}</label>
                <div className="ui checkbox">
                  <input type="checkbox" name="include_flight_ticket" ref={register} defaultChecked={bookingState.booking?.include_flight_ticket ? bookingState.booking?.include_flight_ticket : bookingStateCustom.booking.include_flight_ticket} />
                  <label></label>
                </div>
              </Form.Field>
              : " "
          }

        </Form.Group>

        <Divider variant="middle" />
        <Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings`}><Button>{t("canceled_button")}</Button></Link>
        <Button primary type="submit" loading={bookingStateCustom.processing ? true : false}>{t("save_button")}</Button>
      </Form>
      <ChangeBookingTypeModal
        isOpen={showModal === true}
        onRequestClose={() => dispatch(closeModal())}
        submit={() => dispatch(updateBooking(cruise_id, reservation_id, booking_id, dataForm))}
      />
    </>
  );
}
